import React from 'react';
/* External */
import PropTypes from 'prop-types';
import classnames from 'classnames';

/* Ott-common */
import Icon from '@dtvgo/icon';

/* Components */
import MenuButton from '../MenuButton/MenuButton';

/* Styles — reuses Guide button chrome (same .dtv-common-c-guide-button rules) */
import './KeyMomentsButton.scss';

function KeyMomentsButton({ onClick, tooltip, isExpanded }) {
  return (
    <MenuButton
      onClick={onClick}
      showOnClick={false}
      tooltip={tooltip}
      buttonContent={(
        <div className="dtv-guide-content-button">
          <Icon name="score" />
        </div>
      )}
      className={classnames(
        'dtv-common-c-guide-button',
        isExpanded && 'dtv-common-c-key-moments-toolbar-button--active',
      )}
    />
  );
}

KeyMomentsButton.propTypes = {
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  isExpanded: PropTypes.bool,
};

KeyMomentsButton.defaultProps = {
  onClick: undefined,
  tooltip: '',
  isExpanded: false,
};

export default KeyMomentsButton;
